import styled from 'styled-components';

const VerticalCentered = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
`;

export default VerticalCentered;
